// extracted by mini-css-extract-plugin
export default {"button":"PlayPauseButton_button__daEbI","play":"PlayPauseButton_play__W43gt","loading":"PlayPauseButton_loading__+SyR2","error":"PlayPauseButton_error__2+MOt"};